import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/$tenantSlug/applications/$applicationId")({
  component: () => <Outlet />,
});
